<template>
  <el-row
      v-if="adStore.SB.campaign || adStore.SB.group"
      v-gutter="8"
      type="flex"
      align="middle"
      class="current-position">
    <template v-if="adStore.SB.campaign && adStore.SB.group">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="toCampaignManager"></gj-breadcrumb>
<!--      <div>-->
<!--        <gj-link @click="toCampaignManager">-->
<!--          <gj-icon iconfont="iconback" class="return-icon"></gj-icon>-->
<!--        </gj-link>-->
<!--        <gj-link @click="toCampaignManager">-->
<!--          <span class="current-position&#45;&#45;text">{{adStore.SB.campaign.campaignName | defaultShow}}</span>-->
<!--        </gj-link>-->
<!--        <span class="current-position&#45;&#45;text">/</span>-->
<!--        <span class="current-position&#45;&#45;text">{{adStore.SB.group.groupName | defaultShow}}</span>-->
<!--      </div>-->
    </template>
    <template v-else-if="adStore.SB.campaign">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="toAdManager"></gj-breadcrumb>
<!--      <div>-->
<!--        <gj-link @click="toAdManager">-->
<!--          <gj-icon iconfont="iconback" class="return-icon"></gj-icon>-->
<!--        </gj-link>-->
<!--        <span class="current-position&#45;&#45;text">{{adStore.SB.campaign.campaignName | defaultShow}}</span>-->
<!--      </div>-->
    </template>
  </el-row>
</template>

<script>
  import {adStore} from "../../../common/store";

  export default {
    name: "app-sb-ad-navigator",
    data() {
      return {
        adStore: adStore,
        breadcrumbList: []
      }
    },
    watch: {
      'adStore.SB.campaign': {
        immediate:true,
        handler: function (n, o) {
          // console.log(this.adStore.SB)
          if (n) {
            this.breadcrumbList = [
              {
                name: this.adStore.SB.campaign?.campaignName || '',
                handle: () => {}
              }
            ]
          }
        }
      },
      'adStore.SB.group': {
        immediate:true,
        handler: function (n, o) {
          if (n) {
            this.breadcrumbList = [
              {
                name: this.adStore.SB.campaign?.campaignName || '',
                handle: () => {this.toCampaignManager()}
              },
              {
                name: this.adStore.SB.group?.groupName || '',
                handle: () => {}
              }
            ]
          } else {
            this.breadcrumbList = [
              {
                name: this.adStore.SB.campaign?.campaignName || '',
                handle: () => {}
              }
            ]
          }
        }
      }
    },
    methods: {
      toAdManager() {
        this.adStore.SB.campaign = null;
        this.adStore.SB.group = null;
      },
      toCampaignManager() {
        this.adStore.SB.group = null;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .current-position {
    padding: 16px 0 0 0;
  }
  .current-position--text,
  .return-icon {
    font-size: 12px;
    color: #888;
    margin-right: 8px;
  }
  .current-position--text {
    line-height: 12px;
  }
  /deep/.gj-breadcrumb {
    div {
      line-height: 1;
    }
  }
</style>
